
import {
  Vue,
  Component,
  Watch,
  Prop,
} from 'vue-property-decorator';
import {
  Button,
  Divider,
  Row,
  Col,
} from 'element-ui';
import {
  log,
} from 'util';

@Component({
  components: {
    Button,
    Divider,
    Row,
    Col,
  },
})
export default class addOrModifyCommon extends Vue {
  @Prop({
    required: false,
    default: '',
  }) title!: string;

  @Prop({
    required: false,
    default: '',
  }) isAddPriew!: Boolean;

  @Prop({
    required: false,
    default: () => {},
  }) backCallback!: Function;

  @Prop({
    required: false,
    default: () => {},
  }) resetCallback!: Function;

  @Prop({
    required: false,
    default: () => {},
  }) priewCallBack!: Function;

  @Prop({
    required: false,
    default: () => {},
  }) submitCallback!: Function;

  @Prop({
    required: false,
    default: false,
  }) loading!: boolean;

  // eslint-disable-next-line class-methods-use-this
  back() {

  }
}
